export default __webpack_public_path__ + "mytributes/images/fallback2.jpg";